import * as React from "react";

import {
  Anchor,
  Box,
  Footer,
  Text,
} from "grommet";
import twbLogo from "../static/images/twbLogo.svg";

export default function Foot() {
  return (
    <Box basis="full" align="center" pad={{horizontal: "large"}}>
      <Box width="large">

        <Footer margin={{ top: "large", bottom: "medium" }} justify="center">
          <Text color="grey">
            Powered by{" "}
            <Anchor
              target="_blank"
              rel="no-referrer"
              href="https://po3.ventures"
            >
              Po3 Ventures
            </Anchor>
            &thinsp;<small>©</small>
          </Text>
          <Text color="grey">
            <Anchor
              target="_blank"
              rel="no-referrer"
              href="https://po3.ventures/privacy"
            >
              Privacy
            </Anchor>
          </Text>
        </Footer>
        <Box margin={{ bottom: "xlarge" }} alignSelf="center">
          <img
            width="90px"
            height="90px"
            alt="Together we're better logo"
            src={twbLogo}
          />
        </Box>
      </Box>
    </Box>
  );
}
